<template>
  <el-dialog title="地址信息" :visible.sync="dialogVisible" width="700px" :before-close="handleClose" class="address-dialog" :close-on-press-escape="false" :close-on-click-modal="false" ref="dialog" :loading="loading">
    <div class="address-content" v-loading="loading">
      <div class="address-list">
        <div v-for="(item, index) in list" :key="index">
          <div class="address-list-item" v-if="hasList">
            <div class="label">{{index === 0 ? '地址库' : ''}}</div>
            <div class="address-item" :class="{'is-disabled': isEdit || isAdd}">
              <div class="address-item-detail" @click="chooseAddress(item, index)" :class="{'is-active': item.addressId === activeAddress.addressId}">
                {{item.companyName || item.userName}}
                <img src="../../assets/images/bottom-select.png" alt="">
              </div>
              <div class="edit-btn" style="margin-right: 15px;" @click="editAddress(item)">修改</div>
              <div class="edit-btn" v-if="item.addressId !== activeAddress.addressId" @click="delAddress(item.addressId)">删除</div>
            </div>
          </div>
          <div class="address-detail" v-if="!isEdit && activeAddress.addressId === item.addressId && hasList">
            <div class="label"></div>
            <div class="detail-list">
              <div class="detail-item">
                <span class="detail-label">联系人：</span>
                <span class="detail-content">{{item.userName}}</span>
              </div>
              <div class="detail-item">
                <span class="detail-label">电话号码：</span>
                <span class="detail-content">{{item.userPhone}}</span>
              </div>
              <div class="detail-item">
                <span class="detail-label">电子邮箱：</span>
                <span class="detail-content">{{item.userMail}}</span>
              </div>
              <div class="detail-item">
                <span class="detail-label">所在地区：</span>
                <span class="detail-content">{{item.province}}{{item.city}}{{item.town}}</span>
              </div>
              <div class="detail-item">
                <span class="detail-label">详细地址：</span>
                <span class="detail-content">{{item.companyAddress}}</span>
              </div>
            </div>
          </div>
          <div class="address-list-item" v-if="!isAdd && !isEdit && index === list.length - 1">
            <div class="label">{{hasList ? '' : '地址库'}}</div>
            <div class="add-btn" @click="addAddress">
              <span class="add-btn-icon">+</span>新增地址
            </div>
          </div>
          <div class="edit-address" v-if="(isEdit && activeAddress.addressId === item.addressId) || (isAdd && index === list.length - 1)">
            <div class="label" style="visibility: hidden">{{isAdd ? '新增地址' : '修改地址'}}</div>
            <el-form :model="activeAddress" :rules="rules" ref="ruleForm" label-width="82px" class="address-form">
              <div class="form-title" v-if="isAdd">新增地址</div>
              <el-form-item label="联系人" prop="userName">
                <el-input v-model="activeAddress.userName" maxlength="25"></el-input>
              </el-form-item>
              <el-form-item label="电话号码" prop="userPhone">
                <el-input v-model="activeAddress.userPhone" maxlength="50"></el-input>
              </el-form-item>
              <el-form-item label="电子邮箱" prop="userMail">
                <el-input v-model="activeAddress.userMail" maxlength="80"></el-input>
              </el-form-item>
              <el-form-item label="所在地区" prop="provinceData">
                <el-cascader style="width: 100%;" ref="cascader" clearable :options="provice" filterable :props="props" v-model="activeAddress.provinceData" @keydown.enter.native="handleKeydown"></el-cascader>
              </el-form-item>
              <el-form-item label="详细地址" prop="companyAddress">
                <el-input v-model="activeAddress.companyAddress" maxlength="200"></el-input>
              </el-form-item>
              <el-form-item label="公司名称" prop="companyName">
                <el-input v-model="activeAddress.companyName" maxlength="200"></el-input>
              </el-form-item>
              <el-form-item>
                <el-button type="primary" :loading="addressLoading" @click="saveAddress()">保存</el-button>
                <el-button @click="cancelEdit">取消</el-button>
              </el-form-item>
            </el-form>
          </div>
        </div>
      </div>

    </div>
    <span slot="footer" class="dialog-footer" v-if="!isAdd && !isEdit">
      <!--<el-button @click="handleClose" :disabled="isAdd || isEdit">取消</el-button>-->
      <el-button type="primary" @click="handleSubmit" :disabled="!this.activeAddress.addressId || loading">确定</el-button>
    </span>
  </el-dialog>
</template>

<script>
/**
 * 地址选择
 * */
// import { qryAddressList, saveAddress, delAddress, qryOrgTree } from '~/apis/quote'

export default {
  components: {
  },
  props: {
    value: {
      type: Boolean,
      default: false
    },
    proviceData: {
      type: Array,
      default() {
        return []
      }
    },
    currentData: {
      type: Object,
      default() {
        return {}
      }
    },
    apis: {
      type: Object,
      default() {
        return {}
      }
    }
  },
  data() {
    const validatePhone = (rule, value, callback) => {
      const reg = /^[\d\s-+*#]+$/
      if (!reg.test(value)) {
        return callback(new Error('请输入正确的电话号码'));
      } else {
        return callback()
      }
    }
    return {
      dialogVisible: false,
      loading: true,
      list: [{}],
      hasList: false,
      isAdd: false,
      isEdit: false,
      activeAddress: {},
      form: {},
      rules: {
        userName: [{ required: true, message: '请输入联系人' }, { min: 2, max: 25, message: '长度在 2 到 25 个字符', trigger: 'blur' }],
        userPhone: [{ required: true, message: '请输入电话号码' }, { trigger: 'change', validator: validatePhone }],
        userMail: [{ trigger: 'change', type: 'email', message: '请输入正确的邮箱' }],
        companyAddress: [{ required: true, message: '请输入详细地址' }],
        provinceData: [{ required: true, message: '必填项' }],
      },
      provice: [],
      props: {
        value: 'orgName',
        label: 'orgName',
        children: 'citys'
      },
      addressLoading: false,
      delLoading: false
    }
  },
  computed: {
  },
  watch: {
    value: {
      handler(val) {
        this.dialogVisible = val
        if (val) {
          this.qryList()
        }
      },
      immediate: true
    }
  },
  created() {
  },
  mounted() {
    this.qryCity()
  },
  methods: {
    cancelEdit() {
      this.isAdd = false
      this.isEdit = false
    },
    qryCity() {
      this.apis.qryOrgTree().then(res => {
        res.data.forEach(v => {
          if (!v.citys || !v.citys.length) {
            delete v.citys
          }
        })
        this.provice = res.data || []
        this.$emit('update:proviceData', this.provice)
      }).catch(e => {
      })
    },
    handleKeydown() {
      if (this.$refs.cascader.suggestions.length) {
        this.$refs.cascader.handleSuggestionClick(0)
      }
    },
    chooseAddress(data) {
      if (this.isEdit || this.isAdd) {
        return
      }
      this.activeAddress = Object.assign({}, data)
    },
    editAddress(data) {
      this.isEdit = true
      this.activeAddress = Object.assign({}, data)
      if (this.activeAddress.province) {
        this.activeAddress.provinceData = [this.activeAddress.province]
        if (this.activeAddress.city) {
          this.activeAddress.provinceData.push(this.activeAddress.city)
          if (this.activeAddress.town) {
            this.activeAddress.provinceData.push(this.activeAddress.town)
          }
        }
      }
    },
    addAddress() {
      this.isAdd = true
      this.activeAddress = {}
    },
    saveAddress() {
      this.$refs.ruleForm[0].validate((valid) => {
        if (valid) {
          this.addressLoading = true
          const data = {
            addressId: this.activeAddress.addressId,
            userName: this.activeAddress.userName,
            userPhone: this.activeAddress.userPhone,
            companyName: this.activeAddress.companyName,
            companyAddress: this.activeAddress.companyAddress,
            userMail: this.activeAddress.userMail,
            province: this.activeAddress.provinceData[0],
            city: this.activeAddress.provinceData[1],
            town: this.activeAddress.provinceData[2],
          }
          this.apis.saveAddress(data).then(res => {
            this.$message.success('操作成功')
            this.addressLoading = false
            if (this.isAdd) {
              this.qryList(true)
            } else {
              this.qryList()
            }
            this.isAdd = false
            this.isEdit = false
          }).catch(e => {
            this.addressLoading = false
          })
        } else {
          // this.$message.error('请填写必填项')
          return false;
        }
      })
    },
    delAddress(addressId) {
      this.$confirm('确认删除？', '提示', {
        confirmButtonText: '确定',
        type: 'warning',
        center: true,
        showClose: false
      }).then(() => {
        this.delLoading = true
        this.apis.delAddress({ addressId }).then(res => {
          this.$message.success('删除成功')
          this.delLoading = false
          this.qryList()
          this.$emit('delAddress', addressId)
        }).catch(e => {
          this.delLoading = false
        })
      }).catch()
    },
    qryList(isAdd) {
      this.loading = true
      this.apis.qryAddressList({
        pageRow: 999,
        pageNum: 1
      }).then(res => {
        this.list = res.data.items && res.data.items.length ? res.data.items : [{}]
        if (!res.data.items.length) {
          this.hasList = false
        } else {
          this.hasList = true
          if (!this.activeAddress.addressId) {
            if (this.currentData.addressId) {
              this.activeAddress = Object.assign({}, this.currentData)
            } else {
              this.activeAddress = Object.assign({}, this.list[0])
            }
          }
          if (isAdd) {
            this.activeAddress = Object.assign({}, this.list[this.list.length - 1])
          }
        }
        this.loading = false
      }).catch(e => {
        this.loading = false
      })
    },
    handleCancel() {
    },
    handleClose() {
      this.dialogVisible = false
      this.$emit('input', false)
      this.isAdd = false
      this.isEdit = false
      this.activeAddress = {}
    },
    handleSubmit() {
      this.$emit('updateData', Object.assign({}, this.activeAddress))
      this.handleClose()
    }
  }
}
</script>

<style scoped lang="scss">

</style>
<style lang="scss">
  .address-dialog {
    .el-dialog__header {
      padding: 25px 50px 21px 50px;
      border-bottom: 1px solid #D2D2D2;
      font-size: 18px;
      color: #333333;
      line-height: 18px;
      .el-dialog__headerbtn {
        top: 25px;
        font-size: 23px;
        right: 29px;
      }
    }
    .el-dialog__body {
      padding: 30px 50px 40px 50px;
      .address-list {
        /*display: flex;*/
        .address-list-item {
          display: flex;
        }
        .address-item {
          display: flex;
          width: 100%;
          &:hover .edit-btn {
            display: block;
          }
          &.is-disabled {
            .address-item-detail {
              cursor: not-allowed;
            }
            &:hover .edit-btn {
              display: none;
            }
          }
        }
        .address-item-detail {
          width: 310px;
          height: 30px;
          border: 1px solid #BFBFBF;
          padding: 0 17px;
          font-size: 14px;
          color: #333333;
          line-height: 28px;
          white-space:nowrap;/* 规定文本是否折行 */
          overflow: hidden;/* 规定超出内容宽度的元素隐藏 */
          text-overflow: ellipsis;
          margin-bottom: 6px;
          cursor: pointer;
          position: relative;
          margin-right: 24px;
          img {
            display: none;
            position: absolute;
            bottom: 0;
            right: 0;
          }
          &.is-active {
            border: 2px solid #ca4300;
            img {
              display: block;
            }
          }
        }
        .edit-btn {
          font-size: 14px;
          color: #2828C0;
          line-height: 30px;
          /*display: none;*/
          cursor: pointer;
        }
        .add-btn {
          font-size: 14px;
          color: #ca4300;
          line-height: 30px;
          cursor: pointer;
          .add-btn-icon {
            display: inline-block;
            width: 18px;
            height: 18px;
            background: #FFFFFF;
            border: 2px solid #ca4300;
            border-radius: 50%;
            font-size: 18px;
            font-weight: bold;
            color: #ca4300;
            line-height: 14px;
            margin-top: 6px;
            text-align: center;
            margin-right: 10px;
          }
        }
      }
      .edit-address {
        display: flex;
        margin-top: 14px;
      }
      .label {
        width: 56px;
        height: 30px;
        font-size: 14px;
        color: #333333;
        line-height: 30px;
        margin-right: 28px;
      }
      .address-detail {
        font-size: 14px;
        color: #333333;
        line-height: 18px;
        display: flex;
        margin-top: 14px;
        margin-bottom: 10px;
        .detail-item {
          margin-bottom: 10px;
        }
        .detail-label {
          margin-right: 20px;
          display: inline-block;
          width: 70px;
        }
        .detail-list {
          flex: 1;
          .detail-item {
            display: flex;
            .detail-content {
              flex: 1;
            }
          }
        }
      }
    }
    .el-dialog__footer {
      padding: 0;
      padding-bottom: 33px;
      text-align: center;
      .el-button {
        width: 120px;
        height: 38px;
        border-radius: 0;
      }
    }
    .address-form {
      width: 480px;
      /*height: 377px;*/
      background: #FFFFFF;
      border: 1px solid #BFBFBF;
      padding: 0;
      margin-bottom: 20px;
      .form-title {
        height: 36px;
        background: #FAFAFA;
        font-size: 14px;
        font-weight: bold;
        color: #878787;
        line-height: 36px;
        padding-left: 18px;
        margin-bottom: 21px;
      }
      .el-form-item {
        border: none;
        padding: 0 26px 0 18px;
        margin-bottom: 22px;
        &:first-child {
          margin-top: 21px;
        }
      }
      .el-form-item__label {
        line-height: 36px;
        text-align: left;
        font-size: 14px;
        font-weight: normal;
      }
      .el-input__inner {
        height: 36px;
        border-color: #BFBFBF;
        border-radius: 0;
      }
      .el-button {
        width: 60px;
        height: 32px;
        border-radius: 5px;
        padding: 0;
        text-align: center;
      }
    }
  }
</style>
